<script setup lang="ts">
import { type TextDescription } from 'types';

defineProps<{
    description: TextDescription
}>();
</script>

<template>
    {{ description.value }}
</template>